import { render, staticRenderFns } from "./dialog-policy.vue?vue&type=template&id=4fe57628&"
import script from "./dialog-policy.vue?vue&type=script&lang=js&"
export * from "./dialog-policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports